import _ from 'underscore';
import { getDateOptions } from '../../util/DateUtil';
import moment from 'moment';
import { dateFormats } from '../../util/constants';

export default class TourneyFilterDataProvider {
  constructor(dao) {
    this._dao = dao;
  }

  // cache of filter data promises by tourney ID
  _filterDataPromise = {};

  getFilterData(tourney) {
    const { id: tourneyId, start, end } = tourney;

    const previous = this._filterDataPromise[ tourneyId ];
    if (previous) {
      return previous;
    }

    const { _dao } = this;

    const prom = Promise.all([
      _dao.divisions.getAll({ tourneyId, sort: 'A|name' }),
      _dao.gameGroups.getAll({ tourneyId, sort: 'A|name' }),
      _dao.venues.getAll({ tourneyId, sort: 'A|name' }),
      _dao.courts.getAll({ tourneyId, sort: 'A|name' }),
      _dao.tourneyTeams.getAll({ tourneyId, sort: 'A|name' })
    ]).then(
      ([ divisions, gameGroups, venues, courts, teams ]) => ({
        tourney,
        divisions,
        gameGroups,
        groupTypes: _.chain(gameGroups).pluck('type').uniq().map(t => ({ id: t.toLowerCase(), name: t })).value(),
        venues,
        courts,
        teams,
        dates: _.map(getDateOptions(start, end), date => ({
          id: date,
          name: moment(date, dateFormats.ISO_8601).format('M/D/YY')
        }))
      })
    );

    this._filterDataPromise[ tourneyId ] = prom;

    return prom;
  };
}


// WEBPACK FOOTER //
// ./src/js/GameDay/models/TourneyFilterDataProvider.js